import request from '@/router/axios'

const pre_fix = "/dotadmin/engine/"

export function fetchList (obj) {
  return request({
    url: '/dotadmin/dotPoint/pointListData',
    method: 'post',
    data: obj
  })
}

export function addObj (obj) {
  return request({
    url: '/dotadmin/dotPoint/saveTrDisableStatus',
    method: 'post',
    data: obj
  })
}

export function saveOneEdit (obj) {
  return request({
    url: '/dotadmin/dotPoint/saveOneEdit',// 导入
    method: 'post',
    data: obj
  })
}

export function getObj (query) {
  return request({
    url: '/dotadmin/dotPoint/logList',
    method: 'post',
    data: query
  })
}

export function putObj (obj) {
  return request({
    url: '/dotadmin/dotPoint',
    method: 'put',
    data: obj
  })
}

export function addBackUp (query) {
  return request({
    url: '/dotadmin/dotRisk/addBackUp',
    method: 'post',
    data: query
  })
}

export function removeBackUp (query) {
  return request({
    url: '/dotadmin/dotRisk/removeBackUp',
    method: 'post',
    data: query
  })
}

export function getAllEngineByStatus(obj) {
  return request({
    url: pre_fix + 'getAllEngineByStatus',
    method: 'post',
    params: obj
  })
}

export function getPageEngine(obj) {
  return request({
    url: pre_fix + 'getPageEngine',
    method: 'post',
    data: obj
  })
}

export function getEngineById(obj) {
  return request({
    url: pre_fix + 'getEngineById',
    method: 'post',
    params: obj
  })
}

export function saveEngine(obj) {
  return request({
    url: pre_fix + 'saveEngine',
    method: 'post',
    data: obj
  })
}

export function updateEngine(obj) {
  return request({
    url: pre_fix + 'updateEngine',
    method: 'post',
    data: obj
  })
}

export function statusEngine(obj) {
  return request({
    url: pre_fix + 'statusEngine',
    method: 'post',
    params: obj
  })
}

export function syncEngine(obj) {
  return request({
    url: pre_fix + 'syncEngine',
    method: 'post',
    params: obj
  })
}

